import React from 'react';
import { View, StyleSheet } from 'react-native';
import { BlurView } from 'expo-blur';
import { useSelector } from 'react-redux';
import { getShowPrivacyBlur } from '../reducers/configSlice';
import { isWEB } from '../services/helpers/getPlatformType';
import {
    PRIVACY_BLUR_INTENSITY,
    PRIVACY_BLUR_TINT,
    PRIVACY_OVERLAY_Z_INDEX
} from '../services/privacy/constants';

/**
 * Privacy Blur Component
 *
 * Displays a full-screen blur overlay when the app goes to background
 * to protect sensitive information in task switcher and screen sharing.
 *
 * Features:
 * - Full-screen blur overlay using expo-blur
 * - Simple black blur with no content
 * - Web fallback with solid black overlay
 */
const PrivacyBlur = () => {
    const showPrivacyBlur = useSelector(getShowPrivacyBlur);

    // Don't render if blur should not be shown
    if (!showPrivacyBlur) {
        return null;
    }

    // Web fallback - use solid overlay instead of blur
    if (isWEB()) {
        return <View style={styles.webOverlay} />;
    }

    // Native blur overlay
    return (
        <BlurView
            style={styles.blurOverlay}
            intensity={PRIVACY_BLUR_INTENSITY}
            tint={PRIVACY_BLUR_TINT}
        />
    );
};

// Removed PrivacyContent component - no content needed, just blur

const styles = StyleSheet.create({
    // Blur overlay styles - full screen
    blurOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: PRIVACY_OVERLAY_Z_INDEX, // Highest z-index to ensure it's on top
    },

    // Web fallback overlay - full screen black
    webOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#000000',
        zIndex: PRIVACY_OVERLAY_Z_INDEX,
    },
});

export default PrivacyBlur;
